import skyTile from '../../Homepage/connect/art/tile-sky-soft.jpg';
import mintTile from '../../Homepage/connect/art/tile-mint-mesh.jpg';
import lilacTile from '../../Homepage/connect/art/tile-violet-light-soft.jpg';
import './tiles.css';

/* The landing pages' wallpaper tile (Homepage/connect/sections/Tile.jsx),
   sized for the dashboard (Sandy 2026-10-13: "look at the new homepage for
   that aesthetic ... for all of these"). A soft blurred field with a shadow in
   its own hue, holding one white card. Used sparingly, as on the landing:
   only the thing to look at first (homework to review, a draft to assign) sits
   on a wallpaper; everything else is a plain white card (.sc in tiles.css).
   Same images and hues as the landing; the gradient underneath shows while
   the image loads, so the tile never looks empty. */
export const WALLS = {
  sky: { src: skyTile, hue: '#8CC8F5', soft: '#D8ECFF', shadow: 'rgba(37, 99, 235, .30)' },
  mint: { src: mintTile, hue: '#3CCB8B', soft: '#C8F3DD', shadow: 'rgba(16, 120, 90, .32)' },
  lilac: { src: lilacTile, hue: '#C9B2F2', soft: '#EBE0FB', shadow: 'rgba(91, 33, 182, .28)' },
};

export default function WallTile({ wall = 'sky', className = '', style, children, ...rest }) {
  const w = WALLS[wall] || WALLS.sky;
  return <div className={`wt ${className}`} style={{ '--wt-hue': w.hue, '--wt-soft': w.soft, '--wt-shadow': w.shadow, ...style }} {...rest}>
    <div className="wt-wall" aria-hidden="true"><img src={w.src} alt="" decoding="async" draggable="false" /></div>
    {children}
  </div>;
}
